<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/VsNut2/tc-custom/9781618372475.jpg?1718081189889" alt="This image is the cover for the book Canning & Preserving, Good Food Guaranteed"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Canning & Preserving, Good Food Guaranteed
      </h1>
      <p class="bookDescription body article font2">
        <b>From America's most trusted test kitchen, </b><b>a</b><b> beginner's guide to canning and pickling with more than eighty simple, small-batch recipes—includes photos.</b><br/>  <br/> Making your own great-tasting canned goods is wonderfully easy . . . and a delicious pleasure, too. <i>Good Housekeeping Canning and Preserving</i> teaches you all the techniques you need to get started, such as preparing mason jars and canning equipment and how to form airtight seals. More than eighty recipes feature all-time favorites such as Freezer Strawberry Jam and Classic Dill Pickles, as well as Caramelized Onion and Bacon Jam, Blackberry Preserves, Blushing Apple Butter, Fig Chutney, and more. Plus, you get recipes to show off your creations—including Chutney-Glazed Pork Tenderloin; Spicy Tuna Sandwich with crunchy, pickled green beans; and Prosciutto-Melon Panini made with Cantaloupe Jam.<br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        , Susan Westmoreland
      </h2>
      
      <p class="authorDescription body article">Good Housekeeping is a leading lifestyle media brand inspiring a monthly audience of 30+ million readers to discover genius innovations, delicious ideas, style-savvy trends, compelling news, and best-in-class products for their homes, families, and themselves. The Good Housekeeping Institute’s state-of-the-art labs combined with Good Housekeeping’s seasoned editorial talent and renowned test kitchen is unparalleled. In addition to its US flagship, Good Housekeeping publishes five editions around the world.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?724d67a4